// extracted by mini-css-extract-plugin
export default {"variant":"yqID1","head":"W_Awv","title":"gyh4d","modalTitle":"yqqHi","wrapperIcon":"hlyw7","popup":"SbZwI","parameter":"pwklx"};